import React, { useEffect, useState, useCallback } from "react";
import { Link } from "gatsby";
import TryOut from "../buttons/tryout";

const ParagraphHeroV6 = ({
  data,
  context,
  onClick,
  children,
  terms,
  images,
  ...props
}) => {
  // const { title, buttons, subTitle } = data;
  // const description = data?.description?.processed
  //   ? data?.description?.processed
  //   : data?.description;
  const { className } = props;

  return (
    <div className={className}>
      <CardLeft data={data} terms={terms} />
      <CardRight images={images}></CardRight>
    </div>
  );
};

const CardLeft = ({ data, terms }) => {
  const { title, buttons, subTitle } = data;
  const description = data?.description?.processed
    ? data?.description?.processed
    : data?.description;

  return (
    <div className="w-full lg:max-w-[550px] space-y-8 md:space-y-[32px]   md:min-w-[333px]">
      <div className="space-y-8 md:space-y-5 ">
        <div>
          <h1 className="--hidden --md:block text-center md:text-left text-[32px] sm:text-[40px] lg:text-[64px] font-semibold md:font-medium leading-[1.3] md:leading-[1.2] lg:tracking-[-0.03em] text-[#3D434C] whitespace-pre-line max-w-[340px] md:max-w-full mx-auto px-4 md:px-0 ">
            <span className="block md:text-[24px] lg:text-[26px] md:font-light md:pb-4 md:leading-[26px] md:tracking-tight">
              {subTitle}
            </span>
            <span
              className="md:block md:leading-[64px] md:tracking-[-0.04em]"
              dangerouslySetInnerHTML={{
                __html: title.replace("  ", "<br/>"),
              }}
            />
          </h1>

        </div>
        <div
          className="text-center md:text-left text-xl md:text-[18px] leading-8 text-[#3D434C] font-normal"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      <div className="space-y-5">
        <div className=" flex flex-row md:justify-start justify-center items-center gap-2.5 md:gap-4 ">
          {buttons &&
            buttons.map((item, index) => (
              null
            ))}
        </div>
        <div className="text-[#727C8D] text-sm leading-[14px] text-center md:text-left --md:px-4 md:pb-8">
          {terms}
        </div>
      </div>
    </div>
  );
};

const CardRight = ({ images }) => {
  const [currentItem, setCurrentItem] = useState(0);
  const timeout = 5000;

  const handleTimeout = useCallback(() => {
    setCurrentItem((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);


  const onClick = (e) => {
    const id = parseInt(e.currentTarget.value);
    setCurrentItem(id);
  };

  useEffect(() => {
    const id = setInterval(handleTimeout, timeout);
    return () => {
      clearInterval(id);
    };
  }, [timeout, handleTimeout]);

  return (
    <div className="w-full --border --border-red-400">
      <div className="border p-3 border-[#E3E1DA] rounded-xl bg-[#fff] space-y-2.5">
        <div>
          <TabsBar
            tabs={images.map((c, index) => ({
              ...c,
              index: index,
            }))}
            activeTab={currentItem}
            onTimeout={handleTimeout}
            onClick={onClick}
          />
        </div>

        <Slider images={images} currentIndex={currentItem} />

      </div>

      <Dots />
    </div>
  );
};

const Dots = () => {
  return (
    <div className="-mt-3">
      <div className="xl:hidden h-[73px]"></div>
      <div className="connector !hidden xl:!grid">
        <svg
          width="472"
          height="73"
          viewBox="0 0 472 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="lines"
        >
          <path
            id="path-1"
            d="M11 4.37114e-07L11 44.9481C11 47.074 10.5763 49.1787 9.7537 51.1391L0.999997 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-2"
            d="M52 3.49691e-07L52 45.5551C52 47.2862 51.7191 49.0059 51.1681 50.647L44 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-3"
            d="M93 2.62268e-07L93 46.1858C93 47.5029 92.8374 48.815 92.5158 50.0922L87 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-4"
            d="M134 1.74846e-07L134 46.8356C134 47.723 133.926 48.6089 133.779 49.4841L130 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-5"
            d="M175 8.74228e-08L175 48.169L173 72"
            stroke="#D0CCC1"
          />
          <path id="path-6" d="M215 0L215 72" stroke="#D0CCC1" />
          <path id="path-7" d="M256 0L256 72" stroke="#D0CCC1" />
          <path
            id="path-8"
            d="M297 8.74228e-08L297 48.169L299 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-9"
            d="M338 1.74846e-07L338 46.8356C338 47.723 338.074 48.6089 338.221 49.4841L342 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-10"
            d="M379 2.62268e-07L379 48.169L385 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-11"
            d="M420 3.49691e-07L420 45.5551C420 47.2862 420.281 49.0059 420.832 50.647L428 72"
            stroke="#D0CCC1"
          />
          <path
            id="path-12"
            d="M461 4.37114e-07L461 48.169L471 72"
            stroke="#D0CCC1"
          />
        </svg>
        <div className="dots">
          <div className="dot dot-1 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-2 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-3 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-4 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-5 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-6 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-7 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-8 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-9 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-10 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-11 w-[58px] h-[0px] origin-center rotate-90 "></div>
          <div className="dot dot-12 w-[58px] h-[0px] origin-center rotate-90 "></div>
        </div>
      </div>
    </div>
  );
};

const Button = ({ title, index, uri, ...props }) => {
  const url = uri.replace("internal:/", "/");

  if (index === 0) {
    return (
      <TryOut
        title={title}
        className="text-base  font-medium py-3 px-[30px] rounded-lg leading-[20px] whitespace-nowrap dark:hidden bg-[#325FFF] hover:bg-[#1B4DFF]  text-white border border-[#4A72FF] hover:border-[#3D434C88] demo_account try_it_free_hero "
        //   style={{
        //     boxShadow:
        //     "0px 0.14px 2.29px 0px #1A1D2108, 0px 0.37px 4.43px 0px #1A1D210C, 0px 3px 7px 0px #1A1D2117",
        //    }
        // }
        check={false}
      />
    );
  }

  return (
    <Link
      to={url}
      className="border  rounded-lg px-[30px] py-3 font-medium leading-[20px]  text-[#2D3643] bg-white  --hover:bg-[#F7F9FA] hover:bg-[#F0F3F9]"
      style={{
        boxShadow:
          "0px 0.14px 2.29px 0px #1A1D2108, 0px 0.37px 4.43px 0px #1A1D210C, 0px 3px 7px 0px #1A1D2117",
      }}
    >
      {title}
    </Link>
  );
};

const Slider = ({ images, currentIndex }) => {
  const slides = images.map((item, index) => (
    <div
      className={
        "transition-opacity duration-1000 ease-in-out " +
        (currentIndex === index ? "opacity-100" : " opacity-0")
      }
    >
      <img
        src={item.url}
        alt={`${item.alt}`}
        //className="md:w-[624px] min-w-[350px] mx-auto h-full w-screen"
        key={index}
      />
    </div>
  ));

  return (
    <div className="w-full max-w-3xl  --bg-white --shadow-lg overflow-hidden --rounded-lg mx-auto --mt-20">
      <div
        className="slider-track flex --transition-transform duration-0 --ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className="min-w-full h-full flex items-center justify-center"
          >
            {slide}
          </div>
        ))}
      </div>
    </div>
  );
};

const TabsBar = ({ tabs, activeTab, onClick, onTimeout }) => {
  return (
    <div className="flex flex-row justify-start ml-[9px] gap-[4px]  w-[116px] z-50">
      {tabs.map((t) => (
        <Tab
          title={t.title}
          index={t.index}
          active={activeTab === t.index}
          key={t.index}
          onTimeout={onTimeout}
          onClick={onClick}
        />
      ))}
    </div>
  );
};

const Tab = ({ title, index, active, onTimeout, onClick, timeout = 5000 }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const tick = () => {
      setProgress((prevProgress) => {
        const newProgress = Math.min(prevProgress + (50 / timeout) * 100, 100); // Ensure progress reaches 100%
        return newProgress;
      });
    };

    if (active) {
      const id = setInterval(tick, 50); // Update progress every 100ms
      return () => {
        setProgress(0);
        clearInterval(id);
      };
    }
    return () => {}; // Cleanup for inactive state
  }, [timeout, setProgress, active]);

  useEffect(() => {
    if (active) {
      const id = setInterval(onTimeout, timeout); // Update progress every 100ms
      return () => {
        setProgress(0);
        clearInterval(id);
      };
    }
    return () => {}; // Cleanup for inactive state
  }, [timeout, active, onTimeout]);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        value={index}
        className={
          "text-left   rounded-lg   text-[#3D434C] text-normal  leading-[24px] font-medium  overflow-hidden flex-1 w-[36px] " +
          (active
            ? " bg-[#F3F2EF] border-[#3D434C] hover:bg-[#F9FAFA]"
            : " bg-[#F3F2EF] border-[#DEE1E5] hover:bg-[#F9FAFA]")
        }
        onClick={onClick}
        style={
          active
            ? {
                boxShadow:
                  " 0px 2px 4px -2px #1A1D210F, 0px 4px 8px -2px #1A1D2114",
              }
            : {}
        }
      >
        
        <div
          className={"h-1  " + (active ? "bg-[#4A72FF] " : "")}
          style={{ width: active ? `${progress}%` : "100%" }}
        ></div>
      </button>
    </>
  );
};
export default ParagraphHeroV6;
